import { createPortal } from "react-dom";
import { useTranslate } from "../i18n/useTranslate";
import "./TrekkinConfirm.css";

export default function TrekkinConfirm({
  visible,
  text,
  title,
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
  variant = "danger",
  icon,
}) {
  const translate = useTranslate();
  const resolvedTitle = title ?? translate("common.confirm");
  const resolvedCancelLabel = cancelLabel ?? translate("common.cancel");
  const resolvedConfirmLabel = confirmLabel ?? translate("common.delete");
  const base = import.meta.env.BASE_URL || "/";
  const resolvedIcon = icon || (variant === "recording" ? `${base}icons/stop-record.svg` : null);

  if (!visible) return null;

  const modal = (
    <div
      className="tk-confirm-backdrop"
      onPointerDown={(event) => {
        if (event.target === event.currentTarget) onCancel?.();
      }}
      role="presentation"
    >
      <section
        className={`tk-confirm-dialog tk-confirm-dialog-${variant}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tk-confirm-title"
        aria-describedby="tk-confirm-text"
      >
        {resolvedIcon && <div className="tk-confirm-icon" aria-hidden="true"><img src={resolvedIcon} alt="" /></div>}
        <h2 id="tk-confirm-title" className="tk-confirm-title">{resolvedTitle}</h2>
        <p id="tk-confirm-text" className="tk-confirm-text">{text}</p>
        <div className="tk-confirm-actions">
          <button
            type="button"
            className="tk-confirm-cancel"
            onClick={onCancel}
          >
            {resolvedCancelLabel}
          </button>

          <button
            type="button"
            className="tk-confirm-accept"
            onClick={onConfirm}
          >
            {resolvedConfirmLabel}
          </button>
        </div>
      </section>
    </div>
  );

  if (typeof document === "undefined" || !document.body) {
    return modal;
  }
  return createPortal(modal, document.body);
}
